import script from "./PlayerRank.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerRank.vue?vue&type=script&setup=true&lang=js"

import "./PlayerRank.vue?vue&type=style&index=0&id=acaea12c&lang=scss"

const __exports__ = script;

export default __exports__